import React from 'react';

function Phone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.4116 13.6252C15.5154 13.5561 15.6349 13.514 15.7591 13.5027C15.8834 13.4914 16.0085 13.5113 16.1231 13.5606L20.5444 15.5415C20.6934 15.6052 20.8177 15.7154 20.8989 15.8557C20.98 15.9959 21.0135 16.1587 20.9944 16.3196C20.8487 17.4081 20.3127 18.4066 19.486 19.1295C18.6593 19.8524 17.5982 20.2505 16.5 20.2496C13.1185 20.2496 9.87548 18.9063 7.48439 16.5152C5.0933 14.1241 3.75 10.8811 3.75 7.49961C3.74916 6.40143 4.1472 5.34032 4.87009 4.51361C5.59298 3.68691 6.59152 3.15089 7.68 3.00524C7.84091 2.98612 8.00368 3.01963 8.14395 3.10075C8.28422 3.18187 8.39444 3.30624 8.45813 3.45524L10.4391 7.88024C10.4877 7.99389 10.5076 8.11781 10.4968 8.24098C10.486 8.36414 10.4449 8.48272 10.3772 8.58618L8.37375 10.9684C8.30269 11.0756 8.26066 11.1994 8.25179 11.3278C8.24291 11.4561 8.26749 11.5846 8.32313 11.7006C9.09844 13.2877 10.7391 14.9087 12.3309 15.6765C12.4475 15.7319 12.5766 15.7559 12.7053 15.7462C12.834 15.7365 12.958 15.6934 13.065 15.6212L15.4116 13.6252Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Phone;
